(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const completeLookProducts = JSON.parse(this.dataset.completeLook || '[]');
    const colorVariantProducts = JSON.parse(this.dataset.colorVariants || '[]');
    const DESIRED_PRODUCT_COUNT = 6;

    // Combine both arrays of product IDs to exclude
    const excludedProducts = [...new Set([...completeLookProducts])];

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            const recommendationProducts = Array.from(recommendations.querySelectorAll('.swiper-slide'));
            const filteredProducts = recommendationProducts.filter(product => {
              const productId = parseInt(product.querySelector('[data-product-id]')?.dataset.productId);
              return !(productId && excludedProducts.includes(productId));
            });

            // Only keep the first 4 products after filtering
            const productsToShow = filteredProducts.slice(0, DESIRED_PRODUCT_COUNT);

            // Remove all existing products
            recommendationProducts.forEach(product => product.remove());

            // Add back only the products we want to show
            const swiperWrapper = recommendations.querySelector('.swiper-wrapper');
            productsToShow.forEach(product => {
              swiperWrapper.appendChild(product);
            });

            this.innerHTML = recommendations.innerHTML;
          }

          // Initialize Swiper
          var productslider = [];
          document.querySelectorAll('.product-carousel').forEach(function(Element,index){
            let productid = Element.dataset.id;
            let outer_carousel = Element.closest('.carousel-rowouter');
            let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
            let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
            let swiperObject = {
              loop: eval(Element.dataset.loop),
              slidesPerView: "auto",
              navigation: {
                nextEl: nextbutton,
                prevEl: prevbutton,
              },
            };
            productslider[productid] = new Swiper(Element,swiperObject);
          });
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
